<template>
  <div class="application-page-header">
    <div class="cu-logo-wrapper">
      <img :src="cuLogoUrl" alt="Logo" class="cu-logo" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const cuLogoUrl = computed(() => store.getters["cuLogoUrl"]);
</script>
<style>
.application-page-header {
  border-bottom: 20px solid var(--theme-color);
}
@media (max-width: 992px) {
  .cu-logo-wrapper {
    text-align: center;
  }
}
</style>
